var convert = require('./convert'),
    func = convert('filter', require('../filter'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/fp/filter.js
// module id = 2069
// module chunks = 0